import { defineMessages } from 'react-intl'

export default defineMessages({
  changeMe: {
    id: 'components.PaymentMethodButton.changeMe',
    defaultMessage: '请修改',
    description: '请修改'
  },
  bankCard:{
    id: 'components.PaymentMethodButton.bankCard',
    defaultMessage: 'Bank Card',
    description: '请修改',
  },
  messagePay:{
    id: 'components.PaymentMethodButton.messagePay',
    defaultMessage: 'Message Pay',
    description: '请修改',
  }
})
